export type PaperSize = "A6" | "A4" | "Letter" | "4x6" | "3x4";

export interface PaperSizeConfig {
  name: PaperSize;
  width: string;
  height: string;
  cssSize: string;
}

export const PAPER_SIZE_CONFIGS: Record<PaperSize, PaperSizeConfig> = {
  A6: {
    name: "A6",
    width: "105mm",
    height: "148mm",
    cssSize: "105mm 148mm",
  },
  A4: {
    name: "A4",
    width: "210mm",
    height: "297mm",
    cssSize: "210mm 297mm",
  },
  Letter: {
    name: "Letter",
    width: "8.5in",
    height: "11in",
    cssSize: "8.5in 11in",
  },
  "4x6": {
    name: "4x6",
    width: "4in",
    height: "6in",
    cssSize: "4in 6in",
  },
  "3x4": {
    name: "3x4",
    width: "3in",
    height: "4in",
    cssSize: "3in 4in",
  },
};

export interface CombinedPdfUrls {
  labelUrl?: string;
  packingSlipUrl?: string;
}

export interface PrintSettings {
  paperSize: PaperSize;
  orientation?: "portrait" | "landscape";
  margins?: "default" | "none";
  scale?: "fit" | "100%" | `${Exclude<number, 100>}%` | `${number}.${number}%`;
  pageRange?: "all" | `${number}` | `${number}-${number}` | `${number},${number}`;
}
